import { AdminCategory } from "src/common/types/administrator";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";

export default function adminCategoriesReducer(state: AdminCategory[] = [], action: AnyAction): AdminCategory[] {
  switch (action.type) {
    case internalActionKeys.GET_ADMIN_CATEGORIES:
      return action.adminCategories;
    default:
      return state;
  }
}
